import React from 'react'
import ReactTooltip from 'react-tooltip'
import PropTypes from 'prop-types'

import styles from '../styles/components/tooltip.module.scss'

function Tooltip(props) {
    return (
        <ReactTooltip
            id={props.id}
            type={props.type ? props.type : null}
            multiline={true}
            effect="solid"
            place={props.place}
            className={[styles.tooltip].join(" ")}
            event={props.event}
        >
            <span>{props.label}</span>
        </ReactTooltip>
    )
}

Tooltip.propTypes = {
    label: PropTypes.string.isRequired,
    type: PropTypes.string,
    id: PropTypes.string.isRequired,
    show: PropTypes.bool,
    place: PropTypes.string.isRequired,
}

export default Tooltip
